module.exports = __webpack_public_path__ + "assets/img/cf22-fk.svg";